<!--申请售后-->
<template>
  <div class="apply-container" :style="'min-height:'+min_height+'px;'">
    <header-index/>
    <div class="apply-content" :style="'min-height:'+min_heights+'px;'">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><a @click="goback">返回订单管理</a></el-breadcrumb-item>
      </el-breadcrumb>
      <div class="apply-details">
        <!--商品信息-->
        <div class="order-table">
          <orderTable :state="detailsData.state" :data="[detailsData]" :type="0"/>
        </div>
        <!--申请信息-->
        <div class="apply-info">
          <apply-info :data="detailsData" :state="detailsData.state" @goback="goback"/>
        </div>
      </div>
    </div>
    <Hang/>
    <home_footer/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import Hang from "@/components/Hang/Hang";
import Home_footer from "@/components/footer/home_footer";
import orderTable from "@/components/orderModule/orderTable";
import ApplyInfo from "@/components/orderModule/applyInfo";
import {getMyOrderDetails} from "@/api/orderApi";
export default {
  name: "applyAfterSales",
  components:{ApplyInfo, Home_footer, Hang, headerIndex,orderTable},
  data(){
    return{
      detailsData:{},
      min_height: document.documentElement.clientHeight,
      min_heights: document.documentElement.clientHeight-315,
      orderId:0,
      state:0,
      cid:0,
      type:0,
    }
  },
  methods:{
    /*返回上级页面*/
    goback(){
      this.$router.back(-1);
    },
    /*获取订单详情数据*/
    getOrderDetails(){
      getMyOrderDetails({order_id: this.orderId, uid: this.cid, request: 'form'}).then(res=>{
        if (res.code==200){
          /* type: 1 为一般订单详情 （不包括售后） 2 售后订单详情*/
          if (res.content.type==1){
            this.detailsData=res.content.sselectMyOrderDetailsVo;
            this.state=this.detailsData.state;
            this.type=res.content.type;
          }else{
            this.detailsData=res.content.myOrderRefundVo;
            this.type=this.detailsData.refundType;
          }
        }
      })
    }
  },
  mounted() {
    this.getOrderDetails();
  },
  beforeMount() {
    this.orderId=this.$route.query.id;
    this.cid=JSON.parse(sessionStorage.getItem('loginData')).cid;
  }
}
</script>
<style scoped>
.apply-container >>> .apply-content .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #333333;
  cursor: pointer;
  font-size: 14px;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
}
</style>
<style scoped lang="scss">
.apply-container {
  background: #F1F1F1;

  .apply-content {
    padding: 20px 18%;
    .apply-details{
      background: #ffffff;
      padding: 20px;
      margin-top: 20px;
      .order-table{
        padding-bottom: 30px;
      }
    }
  }
}
</style>